import React from "react";
import { Tab } from "semantic-ui-react";
import ModifyCompForm from "./ModifyCompForm";
const ModifyCompany = () => {
  const panes = [
    {
      menuItem: "Tab 1",
      render: () => (
        <Tab.Pane>
          <ModifyCompForm />
        </Tab.Pane>
      ),
    },
  ];
  return (
    <div>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={panes}
      />
    </div>
  );
};

export default ModifyCompany;
